
import React, { useState, useEffect, useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './Header';
import UserVideosPage from '../../pages/user/UserVideosPage';
import { AuthContext } from '../../contexts/AuthContext';
import { firestoreService } from '../../services/firestoreService';
import { Company } from '../../types';

const UserLayout: React.FC = () => {
  const [company, setCompany] = useState<Company | null>(null);
  const authContext = useContext(AuthContext);
  const companyId = authContext?.user?.companyId;

  useEffect(() => {
    const fetchCompany = async () => {
        if (companyId) {
            try {
                const fetchedCompany = await firestoreService.getCompany(companyId);
                setCompany(fetchedCompany || null);
            } catch (error) {
                console.error("Failed to fetch company details:", error);
            }
        }
    };
    fetchCompany();
  }, [companyId]);

  return (
    <div className="min-h-screen bg-black text-gray-100 flex flex-col">
       <div className="sticky top-0 z-30">
        <Header />
      </div>

      {company && (
          <div 
              style={{ 
                  backgroundColor: company.settings?.branding?.backgroundColor || '#1f2937',
                  color: company.settings?.branding?.primaryColor || '#ffffff'
              }} 
              className="py-4 px-4 sm:px-6 lg:px-8 flex items-center justify-center shadow-lg gap-4"
          >
              {company.settings?.branding?.logoUrl && (
                  <img src={company.settings.branding.logoUrl} alt={`${company.name} Logo`} className="h-10 object-contain" />
              )}
              {company.settings?.branding?.bannerText ? (
                  <h1 className="text-2xl font-bold">{company.settings.branding.bannerText}</h1>
              ) : !company.settings?.branding?.logoUrl ? (
                  <h1 className="text-2xl font-bold">{company.name}</h1>
              ): null}
          </div>
      )}

      <main className="flex-grow container mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Routes>
          <Route path="/" element={<UserVideosPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <footer className="bg-gray-900 text-center py-4 text-gray-500 text-sm">
        MysteryShopperIA Platform
      </footer>
    </div>
  );
};

export default UserLayout;